/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MailSignature } from '../models';
// @ts-ignore
import { MailSignatureBody } from '../models';
/**
 * MailSignatureApi - axios parameter creator
 * @export
 */
export const MailSignatureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * メール署名取得API
         * @summary メール署名取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailSignatureMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/mail_signatures/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * メール署名更新API
         * @summary メール署名更新API
         * @param {MailSignatureBody} [mailSignatureBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailSignatureMe: async (mailSignatureBody?: MailSignatureBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/mail_signatures/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mailSignatureBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MailSignatureApi - functional programming interface
 * @export
 */
export const MailSignatureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MailSignatureApiAxiosParamCreator(configuration)
    return {
        /**
         * メール署名取得API
         * @summary メール署名取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMailSignatureMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailSignature>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMailSignatureMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * メール署名更新API
         * @summary メール署名更新API
         * @param {MailSignatureBody} [mailSignatureBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putMailSignatureMe(mailSignatureBody?: MailSignatureBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putMailSignatureMe(mailSignatureBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MailSignatureApi - factory interface
 * @export
 */
export const MailSignatureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MailSignatureApiFp(configuration)
    return {
        /**
         * メール署名取得API
         * @summary メール署名取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailSignatureMe(options?: any): AxiosPromise<MailSignature> {
            return localVarFp.getMailSignatureMe(options).then((request) => request(axios, basePath));
        },
        /**
         * メール署名更新API
         * @summary メール署名更新API
         * @param {MailSignatureBody} [mailSignatureBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailSignatureMe(mailSignatureBody?: MailSignatureBody, options?: any): AxiosPromise<void> {
            return localVarFp.putMailSignatureMe(mailSignatureBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MailSignatureApi - interface
 * @export
 * @interface MailSignatureApi
 */
export interface MailSignatureApiInterface {
    /**
     * メール署名取得API
     * @summary メール署名取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailSignatureApiInterface
     */
    getMailSignatureMe(options?: AxiosRequestConfig): AxiosPromise<MailSignature>;

    /**
     * メール署名更新API
     * @summary メール署名更新API
     * @param {MailSignatureBody} [mailSignatureBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailSignatureApiInterface
     */
    putMailSignatureMe(mailSignatureBody?: MailSignatureBody, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for putMailSignatureMe operation in MailSignatureApi.
 * @export
 * @interface MailSignatureApiPutMailSignatureMeRequest
 */
export interface MailSignatureApiPutMailSignatureMeRequest {
    /**
     * 
     * @type {MailSignatureBody}
     * @memberof MailSignatureApiPutMailSignatureMe
     */
    readonly mailSignatureBody?: MailSignatureBody
}

/**
 * MailSignatureApi - object-oriented interface
 * @export
 * @class MailSignatureApi
 * @extends {BaseAPI}
 */
export class MailSignatureApi extends BaseAPI implements MailSignatureApiInterface {
    /**
     * メール署名取得API
     * @summary メール署名取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailSignatureApi
     */
    public getMailSignatureMe(options?: AxiosRequestConfig) {
        return MailSignatureApiFp(this.configuration).getMailSignatureMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * メール署名更新API
     * @summary メール署名更新API
     * @param {MailSignatureApiPutMailSignatureMeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailSignatureApi
     */
    public putMailSignatureMe(requestParameters: MailSignatureApiPutMailSignatureMeRequest = {}, options?: AxiosRequestConfig) {
        return MailSignatureApiFp(this.configuration).putMailSignatureMe(requestParameters.mailSignatureBody, options).then((request) => request(this.axios, this.basePath));
    }
}
